import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  useLocation,
  useNavigate,
} from '@tanstack/react-router';
import React from 'react';
import { EarlyAccessTerms, StandardTerms } from '../components/legalDocuments';

export const Route = createFileRoute('/terms-of-use')({
  component: TermsOfUse,
});

function TermsOfUse() {
  const location = useLocation();
  const navigate = useNavigate();

  // Default to Early Access
  const tab = location.hash === 'standard' ? 'standard' : 'early-access';

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    navigate({ hash: newValue, replace: true });
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        data-testid="terms-of-use-page-title"
      >
        Terms of Use
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab label="Early Access" value="early-access" />
          <Tab label="Standard" value="standard" />
        </Tabs>
      </Box>

      {tab === 'early-access' && <EarlyAccessTerms />}
      {tab === 'standard' && <StandardTerms />}
    </Container>
  );
}
